module.exports = __webpack_public_path__ + "static/media/049-RIkochez.f0bc3b13.png";